<template>
  <div :class="[vertical ? 'tab__vertical' : '',
                !vertical ? 'tab__horizontal' : '']">
    <div class="tab__nav">
      <ul>
        <li class="tab__nav__item tab__nav__item__hide" v-if="vertical">
          <p4a-button class="tab__button__icon"
                      :class="{'tab__nav__item__hide--active': !visible}"
                      :fixedWH="true"
                      :showIcon="true"
                      :onlyIconVisible="true"
                      :icon="'menu-collapse'"
                      :disable="false"
                      @click="hideContent">
          </p4a-button>
        </li>
        <li class="tab__nav__item" v-for="tab in registeredTabs" :key="tab.name" :class="{ 'tab__nav__item--active': tab.value === value }">
          <p4a-button  class="tab__button__icon"
                       v-if="vertical"
                       :fixedWH="vertical"
                       :showIcon="true"
                       :onlyIconVisible="vertical"
                       :icon="tab.icon"
                       :text="tab.name"
                       :disable="tab.disabled"
                       @click="tabClicked(tab)">
          </p4a-button>
          <div class="tab__horizontal__button" :class="{ 'tab__horizontal__button--no-icon': !tab.icon }" v-else @click="tabClicked(tab)">
            <p4a-icon class="tab__button__icon" :icon="tab.icon"></p4a-icon>
              <div class="tab__button__label">{{ tab.name }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="tab__content" v-show="visible">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { each, find, remove } from 'lodash'

export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },

    vertical: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: 'valueUpdated'
  },

  data () {
    return {
      registeredTabs: [],
      visible: true
    }
  },

  methods: {
    hideContent () {
      this.visible = !this.visible
    },

    registerTab (tab) {
      this.registeredTabs.push(tab)

      tab.instance.valueUpdated(this.value)
    },

    unregisterTab (tab) {
      remove(this.registeredTabs,
        registeredTab => registeredTab.instance === tab.instance)
    },

    updateTab (tab) {
      find(this.registeredTabs,
        registeredTab => registeredTab.instance === tab.instance)
        .value = tab.value
      
      // We call this function to let the updated tab know what the currently selected value is
      tab.instance.valueUpdated(this.value)
    },

    tabClicked (tab) {
      this.$emit('input', tab.value)
    },

    valueUpdated () {
      each(this.registeredTabs, tab => {
        tab.instance.valueUpdated(this.value)
      })
    }
  }
}
</script>



<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .tab {

    &__button {

        &__label { height: rem(11); }
    }

    &__nav {
      width: 100%;

      &__item {
        position: relative;
        display: inline-block;
        color: $medium-grey-font;

        &:hover {
          color: $dark-grey-font;

          .p4a-icon { color: $dark-grey-font; }
        }

        &--active {
          color: $pending-blue;

          .tab__button__icon { color: $pending-blue; }

          &:hover {
            color: $pending-blue;

            .p4a-icon { color: $pending-blue; }

            .tab__horizontal__button--no-icon { color: $pending-blue; }
          }
        }

        &__hide {
          transform: rotate(180deg);

          &--active { transform: rotate(-180deg); }
        }
      }
    }

    &__vertical {

      .tab__nav {
        width: rem(50);
        top: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        border-bottom: none;

        &__item {

          &:hover {
            color: $dark-grey-font;
            background-color: $light-grey-background;
          }
        }
      }

      .tab__content {
        width: calc(100% - #{rem(50)});
        display: inline-block;
      }
    }

    &__horizontal {

      &__button {
        width: auto;
        height: 100%;
        font-size: rem(12);
        text-align: center;
        position: relative;
        padding: rem(7) rem(10);

        .p4a-icon {
          width: 100%;
          display: block;
          font-size: rem(18);
        }

        &:hover {
          cursor: pointer;
          background-color: $light-grey-background;
        }

        &--no-icon {
          height: rem(25);
          padding: 0 rem(10);
          line-height: rem(25);

          &:hover {
            color: $dark-grey-font;
            background-color: transparent;
          }
        }
      }

      .tab__nav__item--active {

        &:after {
          width: 100%;
          height: rem(3);
          bottom: 0;
          content: '';
          position: absolute;
          background-color: $pending-blue;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Tabs.vue